import {BASE_URL} from '../config';
import axios from '../utils/axios';
import {fetch} from '@app/apiFunction';

export const updateDocAsset = async (payloadGet) => {
  const result = JSON.stringify(payloadGet);
  const token = localStorage.getItem('token');
  const type = 'post';
  const url = BASE_URL + '/file/create';
  const payload = result;
  const resp = fetch(url, type, payload, token);
  return resp;
};

export const deleteFile = async (id) => {
  const token = localStorage.getItem('token');
  const type = 'get';
  const url = BASE_URL + '/file/delete/' + id;
  const resp = fetch(url, type, null, token);
  return resp;
};

export const createDocument = async (data: any) => {
  const token = localStorage.getItem('token');
  const type = 'post';
  const payload = JSON.stringify(data);
  const url = BASE_URL + '/document/create';
  const response = await fetch(url, type, payload, token);
  return response;
};

export const filesDataCreator = (hashes, pId, docId) => {
  try {
    const data =
      hashes &&
      hashes.map((hash) => {
        return createDocument({
          fileHash: hash.hash || '',
          fileName: hash.fileName,
          projectId: pId,
          documentationId: docId
        });
      });
    return data;
  } catch (error) {
    console.log(error, 'error');
  }
};

export const updateDoc = async (payloadGet) => {
  const docIdUpdate = payloadGet.docId;
  const data = delete payloadGet.docId;
  const result = JSON.stringify(payloadGet);
  const token = localStorage.getItem('token');
  const type = 'post';
  const url = BASE_URL + '/documentation/update/' + docIdUpdate;
  const payload = result;
  const resp = fetch(url, type, payload, token);
  return resp;
};

export const createDoc = async (docName, doc, projectId, userRole) => {
  const modified = JSON.stringify({
    documentationName: docName,
    text: doc,
    projectId: projectId,
    isPublic: userRole
  });

  const token = localStorage.getItem('token');
  const url = BASE_URL + '/documentation/create';
  const type = 'post';
  const resp = fetch(url, type, modified, token);
  return resp;
};

export const getDocInfo = async (docId) => {
  const token = localStorage.getItem('token');
  const type = 'get';
  const url = BASE_URL + '/documentation/get-doc/' + docId;
  const resp = await fetch(url, type, null, token);
  return resp;
};

export const getDocFiles = async (docId: any) => {
  const token = localStorage.getItem('token');
  const type = 'get';
  const url = BASE_URL + '/document/getDocument?documentationId=' + docId;
  const resp = await fetch(url, type, null, token);
  return resp;
};

export const getAllDocumentation = async () => {
  const token = localStorage.getItem('token');
  const type = 'get';
  const url = BASE_URL + '/documentation/count-documentation-files';
  const resp = fetch(url, type, null, token);
  return resp;
};

export const getFile = async (fileHash) => {
  const token = localStorage.getItem('token');
  const type = 'get';
  const url = BASE_URL + '/file/get-file?fileHash=' + fileHash;
  const resp = await fetch(url, type, null, token);
  return resp;
};

export const updateFile = async (isPublic, assignedTo, fileId) => {
  if (assignedTo === null) {
    var assignedUser = [];
  } else {
    assignedUser = assignedTo.map((val) => {
      return val.value;
    });
  }

  const payloadGet = {
    isPublic: isPublic,
    assignedTo: assignedUser
  };

  const result = JSON.stringify(payloadGet);
  const token = localStorage.getItem('token');
  const type = 'post';
  const url = BASE_URL + '/file/update/' + fileId;
  const payload = result;
  const resp = fetch(url, type, payload, token);
  return resp;
};

export const fileDeleteHandler = async (id: any) => {
  const url = BASE_URL + '/document/' + id;
  const type = 'post';
  const payload = null;
  const token = localStorage.getItem('token');
  const resp = await fetch(url, type, {}, token);
  return resp;
};

export const getFileUrl = async (hash: any) => {
  const token = localStorage.getItem('token');
  const type = 'get';
  const url = BASE_URL + '/document/getDoc?fileHash=' + hash;
  const resp = await fetch(url, type, null, token);
  return resp;
};
